'use strict';



//////////////////
// WEBPACK FOOTER
// ./~/memoizee/lib/registered-extensions.js
// module id = 607
// module chunks = 0